module.exports = __webpack_public_path__ + "static/media/blackjack-us.919f61eb.jpeg";